import { render, staticRenderFns } from "./Lead.vue?vue&type=template&id=2f30100f&"
import script from "./Lead.vue?vue&type=script&lang=ts&"
export * from "./Lead.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports